import axios from 'axios';
import { API_URL, getAuthHeader } from '.';
import { ResponseModel } from '../Models/ResponseModel';
import { Equipment } from '../Models/Equipment';
import { EquipmentTypeEnums } from '../Models/EquipmentTypeEnums';
import { EquipmentFeature } from '../Models/EquipmentFeature';
import { File } from '../Models/File';
import { Order } from '../Models/Order';
import { OrderItem } from '../Models/OrderItem';
import { SavedItem } from '../Models/SavedItem';

class OrderApi {
  static getOrder(id: number) {
    return axios.get<Order>(`${API_URL}/api/order/${id}`, getAuthHeader());
  }
  static getOrderList() {
    return axios.get<Order[]>(`${API_URL}/api/order/list`, getAuthHeader());
  }
  static addUpdateOrder(request: Order) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/order`,
      request,
      getAuthHeader()
    );
  }
  static addUpdateOrderItem(request: OrderItem) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/order/orderitem`,
      request,
      getAuthHeader()
    );
  }
  static updateOrderItemQuantity(request: OrderItem) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/order/orderitem/updatequantity`,
      request,
      getAuthHeader()
    );
  }
  static deleteOrderItem(id: number) {
    return axios.delete<ResponseModel>(
      `${API_URL}/api/order/orderitem/delete/${id}`,
      getAuthHeader()
    );
  }
}

export default OrderApi;
